export default {
  adms:{
    detail_title: "Detailed information",
    detail_ok: "Ok",
    detail_cancel: "Cancel",
    add_title: "Adding a new asset to the catalog",
    add_cancel: "Cancel",
    add_ok: "Add",
    catalog_title: "Catalog Information",
    catalog_cancel: "Close",
    catalog_ok: "Edit",
    select_title: "Selecting an asset for inclusion in the catalog",
    select_cancel: "Close",
    select_ok: "Select",
    establishing_link_title: "Establish a connection",
    establishing_link_content: "Include selected items in the {{iri}} catalog?",
    establishing_link_ok: "Yes", 
    establishing_link_cancel: "No",
    establishing_link_success: "Connection established!",
    establishing_link_error: "Failed to establish connection. {{e}}",
    break_link_title: "Break the connection", 
    break_link_content: "Do you want to exclude the selected items from the {{iri}} catalog? The data will not be deleted!",
    break_link_ok: "Yes", 
    break_link_cancel: "No",
    break_link_success: "Link delete!",
    break_link_error: "Failed to disconnect. {{e}}",
    list_add_title: "Adding a new item to the catalog",
    list_reload_title: "Reload list",
    catalog_information_title: "Catalog Information",
    jsonld_title: "View JSON+LD Script",
    export_title: "Export to format DOC or PDF",
    export_card: "Export card",
    card_tab_card: "Card",
    card_tab_collaboration: "Collaboration",
    card_tab_content: "Views",
    collaboration: {
      lifecycle_header: "Lifecycle",
      lifecycle_none: "No lifecycle associated with catalog item",
      event_header: "Events",
      event_none: "No events associated with catalog item",
      wiki_header: "Wiki",
    },
    object_property_directories : "Setting up object property directories",
    settings_taxonomy: "Setting taxonomy",
    return_catalog: "Return to the catalog",
    link_asset: "Include asset",
    catalog_lang: "Model catalog language",
    import_card_asset: "Import card catalog"
  },
  model: {
    no_views: "There are no configured views of the catalog item content.",
    no_used: "In the current mode, the view {{view_title}} cannot be used!\n",
    copied_link: "The link to the view has been copied to the clipboard.\n {{url}}",
    copy_link: "Copy link",
    back: "Return to views",
  },
  admin: {
    landing: {
      title: "Catalog Setting",
      schemes: "Models",
      vocabs: "Objects Register",
      sksaowl: "Catalog Ontology",
      catalogs: "Catalogs",
      catalog: "Catalog",
      namespaces: "Namespace Prefixes"
    },
    return_admin_panel: "Return to Setting",
    add_concept_scheme: "Add New Model",
    add_vocabs_individual: "Add New Object to Registry",
    import_conceptscheme: "Import Model",
    import_vocabs_individual: "Import Object",
    return_catalogs: "Return to catalogs list"
  },
  skos: {
    common: {
      ok: "OK",
      cancel: "Cancel",
      close: "Close",
      add: "Add",
      yes: "Yes",
      no: "No",
      deleteSelected: "Delete selected item"
    },
    conceptCard: {
      addProperty: "Add property",
      selectItem: "Select item",
      deleteProperty: "Delete selected property?",
      selectionCancelled: "Object selection was cancelled.",
      reloadToViewChanges: "Reload the page to view the changes."
    },
    schemeList: {
      descriptionRequired: "Please enter a concept scheme description",
      uriExists: "URI {{iri}} already exists. Specify a different identifier.",
      addSuccess: "The record was added successfully.",
      addError: "Failed to add the item to the catalog. {{error}}",
      iriUniquenessError: "Could not determine whether the IRI is unique. {{error}}"
    },
    schemeCard: {
      addProperty: "Add property",
      details: "Details",
      usedBy: "Used by",
      selectConcept: "Select concept",
      rootFlagHelp: "Indicates that the concept is a root item in the scheme",
      rootOrBroaderRequired: "Select either Root in scheme or a broader concept",
      rootInScheme: "Root in scheme",
      broaderConceptHelp: "A broader concept.",
      broader: "Broader",
      conceptDescriptionRequired: "Please enter a concept description",
      editConcept: "Edit concept",
      schemeHasConcepts: "The scheme contains {{count}} concept(s). Delete all concepts before deleting the scheme.",
      recordDeleted: "The record was deleted.",
      conceptDeleted: "The concept was deleted.",
      conceptDeleteError: "Failed to delete the concept.",
      unlinkConcept: "Remove concept from concept scheme",
      conceptUnlinked: "The concept was removed from the scheme.",
      conceptUnlinkError: "Failed to remove the concept from the scheme.",
      uriExists: "URI {{iri}} already exists. Specify a different identifier.",
      linkConceptError: "Failed to link the concept to the scheme. {{error}}",
      backToSchemes: "Return to the concept scheme list",
      addConcept: "Add new concept",
      linkConcept: "Link concept to scheme",
      deleteSchemeAndConcepts: "Delete the scheme and all concepts",
      viewMode: "View mode",
      editMode: "Edit mode",
      removeSchemeFromCatalog: "Remove scheme from catalog",
      schemeDeleted: "The concept scheme was deleted."
    },
    inSchemeCard: {
      hasNarrowerConcepts: "The concept has {{count}} narrower concept(s). Delete them before deleting this concept.",
      deleteUsedConcept: "Concept \"{{name}}\" is in use. Delete it anyway?",
      deleteConcept: "Delete concept \"{{name}}\"?",
      noRelatedConcepts: "No related concepts."
    },
    scheme: {
      used_information: "Information on using the model",
      synchronize: "Export the model to another graph."
    },
    export: {
      model: "Export Model"
    }
  },
  catalog: {
    graph_field : "Graph",
    export: "Export catalog"
  }
}
